module.exports = __webpack_public_path__ + "img/loading.93555163.gif";